module.exports = __webpack_public_path__ + "static/khanacademy-0be6ba9583658beca7f49784811d6e95.svg";